export default import.meta.ROLLDOWN_FILE_URL_HSrOseFivlq9XBxiNU5wYA